import type { GeocodeQueryInterface } from './geocode-query.interface';

export interface SuggestQueryInterface extends GeocodeQueryInterface {}
